.filledNumberedList {
	display: flex;
	flex-direction: column;
	gap: 5px;
	list-style-type: none;
	counter-reset: filled-numbered-list-counter;
	margin: 0;
	padding: 0;
}

.filledNumberedListItem {
	display: flex;
	gap: 10px;
	counter-increment: filled-numbered-list-counter;
}

.filledNumberedListItem::before {
	content: counter(filled-numbered-list-counter);
	background: var(--primary-active-background-color);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 0.7rem;
	width: 1.2rem;
	height: 1.2rem;
	font-weight: 800;
	text-align: center;
	color: white;
	border-radius: 50%;
}
